export default function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#f8f6f3] via-[#faf8f6] to-[#f5f1ed]">
      <div className="text-center">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent mb-4"></div>
        {/* <p className="text-slate-600 font-medium">Loading...</p> */}
      </div>
    </div>
  );
}
